import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';
import { forwardRef } from 'react';
import { Icon } from '@hotjar/webapp/components/Icon';

export const Heading = styled.span`
  white-space: nowrap;
  font-weight: normal;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0.1px;
  color: ${tokens.color.text_default};
`;

export const VatTotal = styled.div`
  white-space: nowrap;
  color: ${tokens.color.text_light};
  font-size: 12px;
  line-height: 140%;
`;

const StyledIcon = styled(Icon)`
  margin: 0 0 5px 5px;
`;

export const FooterCTA = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

type Ref = HTMLSpanElement;
type IconProps = {
  color: string;
  icon: string;
  size: number;
};

export const InfoIcon = forwardRef<Ref, IconProps>((props, ref) => {
  return (
    <span ref={ref}>
      <StyledIcon {...props} />
    </span>
  );
});

InfoIcon.displayName = 'InfoIcon';
